<script lang="ts" setup>
const {
    title,
    summary = '',
    iconRef = '',
    titleClass = 'text-brand',
    summaryClass = 'text-grey',
    headerClass = '',
    iconClass = 'size-18 tablet:size-10 laptop:size-16 text-grey mx-auto mb-6'
} = defineProps<{
    title: string,
    titleClass?: string,
    summary?: string,
    headerClass?: string,
    summaryClass?: string,
    iconRef?: string,
    iconClass?: string
}>();
const iconComponent = computed(() => {
    if (!iconRef) return null
    return defineAsyncComponent(() =>
            import(`~/components/icon/${iconRef}.vue`)
    )
})
</script>

<template>
  <article>
    <header :class="headerClass">
      <component
              :is="iconComponent"
              v-if="iconComponent"
              :class="iconClass"/>
      <h3
              :class="titleClass"
              class="article-title mb-3">
        {{ title }}
      </h3>
      <slot name="subtitle"/>
    </header>
    <div :class="summaryClass">
      <p v-if="summary">{{ summary }}</p>
      <slot name="summary"/>
    </div>
  </article>
</template>

<style scoped>

</style>